export default __webpack_public_path__ + "static/media/popUp-accepted-icon.73556b2c.svg";